let REVIEW_MODE_WINDOW;

try {
  REVIEW_MODE_WINDOW = window.parent;
} catch (err) {
  console.warn('some error getting the parent window. . .', err);
}

interface IPostMessageData {
  type: string;
  data: string;
}

export function reviewToolPostMessage(postMessageData: IPostMessageData) {
  if (REVIEW_MODE_WINDOW) {
    // try {
    //   REVIEW_MODE_WINDOW?.postMessage(
    //     postMessageData,
    //     '*.chameleoncreator.com'
    //   );
    // } catch (err) {
    //   if (window.dev()) {
    //     REVIEW_MODE_WINDOW?.postMessage(postMessageData, '*');
    //   }
    // }
    REVIEW_MODE_WINDOW?.postMessage(postMessageData, '*');
  }
}

export function reviewToolPostMessageOnMessage(
  fN: (e: { [key: string]: any }) => void
): () => void {
  window.addEventListener('message', fN);

  return () => {
    window.removeEventListener('message', fN);
  };
}
